import { filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { RentingService } from 'src/app/services/renting.service';
import { UserServiceService } from 'src/app/services/user-service.service';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public rentings:any[]=[];
  public users:any[]=[];
  public cars:any[]=[];
  constructor(
    private locationService:RentingService,
    private userService:UserServiceService,
    private carService:VehiculeserviceService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData()
  {
      this.locationService.index('none').subscribe((res:any)=>{
        console.log(res);
        this.rentings = res.rentings
        this.rentings= this.rentings.filter((elt:any)=> elt.renting_status =="EN_ATTENTE")
      })
   
      this.userService.getUser().subscribe((res:any)=>{
       this.users = res
       this.users= this.users.filter((elt:any)=> elt.user_status ==1)
      })
   
      this.carService.getallvehicleAdmin().subscribe((res:any)=>{
        this.cars= res;
        this.cars=  this.cars.filter((elt:any)=> elt.status =="indisponible")
      })
  }

}
